var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOdometer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a184a6f6-9cd2-4c62-8f73-4510448e44c1",
    "data-name": "Camada 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bd7c2745-7261-498e-9dee-b37efe78e982",
    "data-name": "Camada 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0H24V24H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "f6109574-bf80-46c2-9e37-3f57c75686d8",
    "data-name": "a11205b2-b4a3-4393-aa54-b8714f708419"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 22,
    height: 22,
    rx: 1.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M5.83,13l-1,1.09v2.67H2.9V7.4H4.83v4.23l.85-1.16L8.06,7.4h2.36L7.11,11.55l3.41,5.2H8.23Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.77,7.4l2.4,6.79L18.56,7.4H21.1v9.35H19.17V14.19l.18-4.42-2.53,6.94H15.44L12.92,9.77l.27,4.42v2.56H11.26V7.4Z",
    fill: "#fff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOdometer);
export default __webpack_public_path__ + "static/media/odometer.634f0cba54f477e0ea564d470e919138.svg";
export { ForwardRef as ReactComponent };